import canadaFlagIcon from "./resources/images/canadaFlagIcon.svg";
import filterIcon from "./resources/images/filterIcon.svg";
import medalIcon from "./resources/images/medalIcon.svg";

export const FILTERS = {
    MEDAL: {
        title: "Medal",
        src: medalIcon,
    },

    TEAM_CANADA: {
        title: "Team Canada",
        src: canadaFlagIcon,
    },
};

export const FILTER_ICON = {
    src: filterIcon,
};
